import { Link } from 'react-router-dom';
import '../styles/service.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';

function Si() {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      <section id="si-banner">
        <div className="content-padding si-banner-container">
          <div className="si-title m-auto">
            <div>
              <h2 className="color-primary">SI 서비스 및 컨설팅</h2>
              <p className="fs-md mt-20">
                고객의 비즈니스 혁신을 실현하는 맞춤형 시스템 통합 서비스
              </p>
            </div>
            <div>
              <Link to="/contact?service=si&no=01" className="fw-bold fs-base">
                서비스 도입 문의
              </Link>
            </div>
          </div>
          <div className="si-banner-content m-auto">
            <div className="si-banner-box">
              <div className="si-banner-item fs-base">
                다양한 산업 분야에 적합한 <br />
                <strong>맞춤형 서비스 및 컨설팅</strong> 제공
              </div>
              <div className="si-banner-item fs-base">
                고객의 비즈니스 경쟁력을 높이는 <br />
                <strong>맞춤형 디지털 전환</strong> 제공
              </div>
            </div>
            <div className="si-banner-title-center">
              <div className="si-banner-title fs-xl fw-bold">
                SI Service
                <br />
                IT Consulting
              </div>
            </div>
            <div className="si-banner-box">
              <div className="si-banner-item fs-base">
                <strong>기획부터 구축, 운영까지</strong> <br />
                End-to-End로 제공
              </div>
              <div className="si-banner-item fs-base">
                <strong>축적된 노하우와 검증된 프레임워크 기반</strong>
                <br />
                신뢰할 수 있는 통합 솔루션 제공
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="si-content">
        <div className="si-content-container m-auto">
          <div className="si-content-main">
            <h3>주요 영역</h3>
            <ul className="content-bg si-main-box">
              <li className="si-main-item">
                <div>
                  <img src="./images/ico-si-main01.svg" alt="" />
                  <p className="fs-base fw-bold">IT 컨설팅</p>
                  <p className="fs-base color-caption">
                    프로세스 분석, 요구사항 정의, <br />
                    IT 전략 수립 등 사전 진단 및 설계
                  </p>
                </div>
              </li>
              <li className="si-main-item">
                <div>
                  <img src="./images/ico-si-main02.svg" alt="" />
                  <p className="fs-base fw-bold">시스템구축(SI)</p>
                  <p className="fs-base color-caption">
                    업무 특성에 맞춘 맞춤형 웹/모바일 <br />
                    시스템 개발 및 연계 통합
                  </p>
                </div>
              </li>
              <li className="si-main-item">
                <div>
                  <img src="./images/ico-si-main03.svg" alt="" />
                  <p className="fs-base fw-bold">IT 컨설팅</p>
                  <p className="fs-base color-caption">
                    안정적인 서비스 운영을 위한 <br />
                    기술 지원 및 유지보수 제공
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div className="si-content-main">
            <h3>Project Process</h3>
            <div className="si-project-process">
              <img src="./images/img-si-process.svg" alt="si-project-process" />
            </div>
            <div className="si-project-process-mo">
              <img src="./images/img-si-process-mo.svg" alt="si-project-process" />
            </div>
          </div>
        </div>
      </section>
      <section id="si-strength" className="si-strength-container">
        <div className="content-padding m-auto">
          <h3 className="content-title">
            <strong>TAKE</strong>와 함께하는 이유
          </h3>
          <div className="si-strength-content">
            <div className="si-strength-content02">
              <div className="si-strength-item">
                <p className="si-strength-title fs-md fw-bold">
                  풍부한 프로젝트 경험과 산업 이해도
                </p>
                <p className="text-dot fs-base">
                  공공기관, 제조, 유통 등 다양한 분야의 SI 프로젝트 수행 경험
                </p>
              </div>
              <div className="si-strength-item">
                <p className="si-strength-title fs-md fw-bold">전문 인력 중심의 조직 운영</p>
                <p className="text-dot fs-base">
                  SI 경력을 보유한 수석 및 책임급 인력이 기획부터 운영까지 담당
                </p>
              </div>
            </div>
            <div className="si-strength-content02">
              <div className="si-strength-item">
                <p className="si-strength-title fs-md fw-bold">
                  풍부한 프로젝트 경험과 산업 이해도
                </p>
                <p className="text-dot fs-base">
                  고객의 니즈에 맞춘 정밀한 요구사항 분석과 프로세스 개선 제안
                </p>
              </div>
              <div className="si-strength-item">
                <p className="si-strength-title fs-md fw-bold">기술 변화에 대한 민첩한 대응력</p>
                <p className="text-dot fs-base">
                  고객의 기술 도입 타이밍에 알맞은 최적의 기술 적용 전략 제안
                </p>
              </div>
            </div>
            <div className="si-strength-content02">
              <div className="si-strength-item">
                <p className="si-strength-title fs-md fw-bold">
                  검증된 플랫폼 기반의 빠르고 안정적인 개발
                </p>
                <p className="text-dot fs-base">자체 플랫폼(UXBooster) 기반의 개발 환경 제공</p>
                <p className="text-dot fs-base">
                  반복업무 · UI 작업 자동화 → 개발속도 UP, 오류 DOWN
                </p>
              </div>
              <div className="si-strength-item">
                <p className="si-strength-title fs-md fw-bold">지속 가능한 협력 관계 지향</p>
                <p className="text-dot fs-base">
                  단발성 계약이 아닌 장기적인 파트너십 구축 → 신뢰 기반의 협업
                </p>
                <p className="text-dot fs-base">
                  시스템 구축 후에도 지속적인 유지보수 및 기능 개선 서비스 제공
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="si-contact">
        <div className="contact-container m-auto">
          <div
            className="contact-text"
            data-aos="fade-up"
            data-aos-duration="400"
            data-aos-once="true"
          >
            <p className="fs-xxl">지금 바로</p>
            <img className="si-contact-logo" src="./images/logo-white.svg" alt="takelogo" />
            <p className="fs-xxl">를 만나보세요!</p>
          </div>
          <div
            className="contact-button fs-base"
            data-aos="fade-up"
            data-aos-duration="400"
            data-aos-once="true"
            data-aos-delay="300"
          >
            <Link to="/contact?service=si&no=01" className="color-primary fw-bold">
              서비스 도입 문의
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default Si;
